export enum RiskSeverity {
  LOW = 'Low',
  HIGH = 'High',
  MEDIUM = 'Medium',
  CRITICAL = 'Critical',
}
